// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EstateLabel_wrapper__qSNmW","logo":"EstateLabel_logo__3zIS4","builder":"EstateLabel_builder__3r6a-"};